module.exports = __webpack_public_path__ + "static/media/da-ct-scan-1.b60632c8.jpg";